module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/tablet@2x-63cef320bbdaec1b99610b75ab1a7de2.jpg";